import type { GetStaticProps, GetStaticPaths } from "next"
import toolsData from "@/constants/tools/tools.json"
import { DOG_COST_CALCULATOR_ID } from "@/constants/tools/routes"

export { default } from "@/components/tools/ToolPageLayout"

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = Object.keys(toolsData)
    .filter((tool) => tool !== DOG_COST_CALCULATOR_ID)
    .map((tool) => ({ params: { tool } }))

  return {
    paths,
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const toolId = params?.tool as string
  const toolData = toolsData[toolId as keyof typeof toolsData]

  if (!toolData) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      toolId,
      toolData,
    },
    revalidate: 60 * 60 * 24,
  }
}
